import { render, staticRenderFns } from "./OldStudentTable.vue?vue&type=template&id=35fb5247&scoped=true&"
import script from "./OldStudentTable.vue?vue&type=script&lang=js&"
export * from "./OldStudentTable.vue?vue&type=script&lang=js&"
import style0 from "./OldStudentTable.vue?vue&type=style&index=0&id=35fb5247&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb5247",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VDataTable,VIcon,VTooltip})
